module.exports = __webpack_public_path__ + "static/media/top.22a45f71.png";